import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { api } from 'app';
import Button from 'packages/ui/Button';
import Modal, { ModalHeader, ModalBody, ModalFooter } from 'packages/ui/Modal';
import PersianNumber from 'packages/ui/PersianNumber';

const Wrapper = styled('div')`
  font-size: 28px;
  line-height: 40px;
  text-align: center;
`;

function RequestAvailableAudience({ buttonType, campaignId, channel, filters }) {
  const [statistics, setStatistics] = useState();
  const [status, setStatus] = useState('none');

  const handleClose = () => {
    setStatus('none');
    setStatistics(null);
  };

  const handleRequestStatistics = () => {
    setStatus('submitting');

    const data = {
      channel,
      filters
    };

    if (campaignId) {
      data.campaign_id = campaignId;
    }

    api
      .post('/advertising-campaigns/filter-statistics', data)
      .then(response => response.json())
      .then(response => {
        setStatus('submitSucceeded');
        setStatistics(response.data);
      })
      .catch(error => {
        setStatus('submitFailed');
        setStatistics(undefined);
      });
  };

  return [
    <Button
      key="button"
      mood="secondary"
      onClick={handleRequestStatistics}
      type={buttonType}
      working={status === 'submitting'}
    >
      درخواست آمار دریافت‌کنندگان
    </Button>,

    <Modal
      key="modal"
      onHide={handleClose}
      show={status === 'submitSucceeded' || status === 'submitFailed'}
      size="small"
    >
      <ModalHeader>تعداد افراد قابل ارسال</ModalHeader>

      <ModalBody>
        {status === 'submitFailed' && 'متاسفانه مشکلی در دریافت اطلاعات رخ داد.'}

        {status === 'submitSucceeded' && (
          <Wrapper>
            <PersianNumber value={statistics.total_contacts} format />
          </Wrapper>
        )}
      </ModalBody>

      <ModalFooter>
        <Button mood="secondary" onClick={handleClose}>
          بستن
        </Button>
      </ModalFooter>
    </Modal>
  ];
}

RequestAvailableAudience.propTypes = {
  buttonType: PropTypes.string,
  campaignId: PropTypes.number,
  channel: PropTypes.oneOf(['email', 'sms']).isRequired,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      filter_params: PropTypes.object,
      filter_type: PropTypes.string
    })
  )
};

RequestAvailableAudience.defaultProps = {
  buttonType: 'button'
};

export default RequestAvailableAudience;
